// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tYJDP","colBig":"styles_colBig__NI_R_","colSmall":"styles_colSmall__2AiHr"};